import apiClient from "../api/apiClient"
import { endPoints } from "../config/endpoints";

export const countryService = {
    async getDropdownAsync() {
      const response = await apiClient.get(endPoints.country.dropdown);
      return response.data;
    },
     async getAllAsync(params) {
    const response = await apiClient.get(endPoints.country.getAll, {
      params: params,
    });

    return response.data;
  },
  async getAllSearchAsync(params, signal) {
    const response = await apiClient.get(endPoints.country.getAllSearch, {
      params: params,
      signal: signal,
    });

    return response.data;
  },
  async toggleActivate(id) {
    const response = await apiClient.patch(
      `${endPoints.country.toggleActivate}/${id}`,
    );
    return response.data;
  },
  async create(data) {
    const response = await apiClient.post(endPoints.country.create, data);
    return response.data;
  },
  async update(id, data) {
    const response = await apiClient.put(
      `${endPoints.country.update}/${id}`,
      data,
    );
    return response.data;
  },
  async edit(id) {
    const response = await apiClient.get(`${endPoints.country.edit}/${id}`);
    return response.data;
  },
   async deleteAsync(id) {
    const response = await apiClient.delete(
      `${endPoints.country.delete}/${id}`,
    );
    return response.data;
  },
  async getDetails(id) {
    const response = await apiClient.get(
      `${endPoints.country.getDetails}/${id}`,
    );
    return response.data;
  }
}
